export type SelectProjectResponse =
    | {
          success: true;
      }
    | {
          success: false;
          error_code: string;
          error_message: string;
      };
